<template>
    <iframe
        :src="streamSrc"
        class="beter-stream-iframe"
        name="beter-stream"
        allowfullscreen
    ></iframe>
</template>
<script>
    export default {
        name: 'BeterPlayer',
        props: {
            streamId: {
                type: String,
                required: true,
            },
        },
        computed: {
            streamSrc() {
                return `https://fbstreambro.cc/embed.php/?match_id=${this.streamId}`;
            },
        },
    };
</script>
<style lang="scss" scoped>
.beter-stream-iframe {
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    border:none;
    margin:0;
    padding:0;
    overflow:hidden;
}
</style>
